import type { BrandProfile } from './BrandProfile'

/**
 * Астерікс — бренд стенду за замовчуванням (`SPEC-014` §1.5).
 *
 * Значення рівно ті, що стояли в `BrandConfig` до появи профілів: без
 * `VITE_BRAND` стенд виглядає так само, як і раніше.
 */
export const asterix: BrandProfile = {
    id: 'asterix',
    name: 'ASTERIX GROUP',
    shortName: 'ASTERIX GROUP',
    /** Кораловий легасі (`SPEC-014` §1.5, Q14.1). */
    color: '#ED7768',
    /**
     * Поки замовник не дав вектора (Q14.2), знак — растрова вирізка з логотипа
     * легасі без прозорості, тому на білій плашці.
     */
    mark: { src: '/assets/brand/mark.png', plate: true },
    html: {
        title: 'ASTERIX GROUP',
        favicon32: '/favicon-32.png',
        icon192: '/icon-192.png',
        appleTouchIcon: '/apple-touch-icon.png',
    },
    login: {
        /*
         * Фото легасі `back.webp` під темним шаром: знімок строкатий, і без
         * затемнення ні білий текст ліворуч, ні картка на світлих ділянках не
         * читалися б. Ліворуч, під текстом, шар густіший.
         */
        background:
            'linear-gradient(90deg, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0.5) 55%, rgba(0, 0, 0, 0.42) 100%), ' +
            "url('/assets/brand/back.webp') center / cover no-repeat, #1f1f1f",
        /*
         * Тексти — рішення замовника 2026-10-14, як на демо-стенді. Три рядки
         * не повторюють одне одного: заголовок каже «що це», пояснення — «що
         * тут робити», підпис — «з чого складається» (розділи в порядку меню).
         */
        headline: ['Логістична CRM'],
        lead: ['Клієнти, перевізники й справи в одному місці.', 'Увійдіть, щоб продовжити.'],
        caption: 'Справи · Клієнти · Перевізники · Листи',
    },
}
